import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination'; // Optionnel, si vous voulez des points de pagination plus tard
import 'swiper/css/autoplay'; // !! NOUVEAU: Import pour les styles de l'autoplay (si nécessaire)

// import required modules
import { Navigation, A11y, Autoplay } from 'swiper/modules'; // !! NOUVEAU: Autoplay ajouté

// Assurez-vous que ProductCard.js existe et est importé correctement
import ProductCard from './ProductCard';
// Importez le fichier CSS correspondant
import './ServicesList.css';

// --- Données des services pour Studio Ambre ---
const servicesData = [
  {
    id: 's1',
    name: "Coupe Femme",
    description: "Shampoing, coupe personnalisée adaptée à votre style et coiffage.",
    imageSrc: "/images/a222.jpeg" // Assurez-vous que ce chemin est correct depuis le dossier public
  },
  {
    id: 's2',
    name: "Coupe Homme",
    description: "Coupe classique ou tendance, entretien de barbe possible sur demande.",
    imageSrc: "/images/a5.jpeg"
  },
  {
    id: 's3',
    name: "Couleur (Racines / Complète)",
    description: "Application professionnelle pour une couleur uniforme et éclatante.",
    imageSrc: "/images/a16.jpeg"
  },
  {
    id: 's4',
    name: "Balayage / Mèches",
    description: "Techniques variées pour apporter lumière et relief à votre chevelure.",
    imageSrc: "/images/a2.jpeg"
  },
  {
    id: 's5',
    name: "Soins Capillaires Profonds",
    description: "Réparez et hydratez vos cheveux avec nos soins spécifiques en salon.",
    imageSrc: "/images/a12.jpeg"
  },
  {
    id: 's6',
    name: "Coiffure Événementielle",
    description: "Chignons, tresses, coiffures sophistiquées pour mariages et occasions spéciales.",
    imageSrc: "/images/a15.jpeg"
  },
  {
    id: 's7',
    name: "Coloration Végétale", // Nouveau service
    description: "Des couleurs douces et naturelles pour une chevelure respectée. Sur devis.",
    imageSrc: "/images/a33.jpg" // Chemin d'image à adapter
  },
  {
    id: 's8',
    name: "Coupe Enfant", // Nouveau service
    description: "Des coupes adaptées aux plus jeunes, dans une ambiance conviviale.",
    imageSrc: "/images/enfant.jpeg" // Chemin d'image à adapter
  }
];

function ServicesList() {
  return (
    <section id="services" className="services-list-section">
      <div className="container">
        <h2 className="section-title">Nos Services Coiffure</h2>
        <p className="section-subtitle">
          Découvrez une sélection de nos prestations pour femmes, hommes et enfants.
        </p>

        <Swiper
          modules={[Navigation, A11y, Autoplay]} // !! NOUVEAU: Autoplay ajouté aux modules
          spaceBetween={20}
          slidesPerView={1}
          navigation // Active les flèches de navigation par défaut (< >)
          loop={true} // Mis à true pour un défilement infini, souvent souhaité avec l'autoplay
          autoplay={{ // !! NOUVEAU: Configuration de l'autoplay
            delay: 3500, // Temps en ms entre chaque transition
            disableOnInteraction: false, // L'autoplay ne s'arrête pas après une interaction utilisateur (swipe)
            pauseOnMouseEnter: true,      // Met en pause l'autoplay quand la souris est sur le slider
          }}
          grabCursor={true}
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 25
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30
            }
          }}
          className="services-swiper-container"
        >
          {servicesData.map(service => (
            <SwiperSlide key={service.id}>
              <ProductCard
                name={service.name}
                description={service.description}
                imageSrc={service.imageSrc}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default ServicesList;